// In dev: create a .env.local file with:
//   REACT_APP_API_URL=http://localhost:8080/api/router.php
// Then run `php -S localhost:8080` from the project root to test PHP locally.
// Leave REACT_APP_API_URL unset to hit the production server directly.
const BASE = process.env.REACT_APP_API_URL ?? 'https://simplemcnetwork.net/api/router.php';


const api = async (usedFunction, dataSend = {}) => {
    try {
        const response = await fetch(BASE, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ function: usedFunction, data: dataSend }),
        });

        const result = await response.json();
        const { success, message, data, ...rest } = result;
        return {
            isSuccess: success,
            message: message ?? null,
            // Support both nested { data: {...} } and flat { field1, field2, ... } responses
            data: data ?? (Object.keys(rest).length > 0 ? rest : null),
        };
    } catch (error) {
        return { isSuccess: false, message: error.message, data: null };
    }
};

export default api;